"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationAction = exports.useConfirmation = exports.Confirmation = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EnhanceChildren_1 = require("../../enhance-children/EnhanceChildren");
const I18n_1 = require("../../i18n/I18n");
const UI_1 = require("../UI");
const Confirmation = ({ callback, children, title, }) => {
    const { t } = I18n_1.useTranslation();
    return (jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsx("div", { children: title || t("Confirm ?") }, void 0),
            jsx_runtime_1.jsx("div", { children: children }, void 0),
            jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsxs("button", Object.assign({ onClick: () => callback(false) }, { children: [t("Cancel"), " "] }), void 0),
                    jsx_runtime_1.jsx("button", Object.assign({ onClick: () => callback(true) }, { children: t("OK") }), void 0)] }, void 0)] }, void 0));
};
exports.Confirmation = Confirmation;
function useConfirmation(_a) {
    var { Component, callback } = _a, props = tslib_1.__rest(_a, ["Component", "callback"]);
    if (!Component) {
        Component = exports.Confirmation;
    }
    const [confirmation, setConfirmation] = react_1.useState(false);
    const confirmCallback = (confirm) => {
        setConfirmation(false);
        callback(confirm);
    };
    return {
        confirmation: confirmation ? jsx_runtime_1.jsx(Component, Object.assign({ callback: confirmCallback }, props), void 0) : null,
        setConfirmation,
    };
}
exports.useConfirmation = useConfirmation;
function ConfirmationAction(props) {
    const { useLoader, useSuccessNotification, useErrorNotification, useConfirmation, } = UI_1.useUIContext();
    const { loader, loading, setLoading } = useLoader({});
    const { successNotification, setSuccessNotification } = useSuccessNotification({
        title: props.title,
    });
    const { errorNotification, setErrorNotification } = useErrorNotification({ title: props.title });
    const { onSuccess } = props;
    const [success, setSuccess] = react_1.useState();
    react_1.useEffect(() => {
        if (success && onSuccess) {
            setSuccess(undefined);
            onSuccess(success);
        }
    }, [success, onSuccess]);
    const { confirmation, setConfirmation } = useConfirmation({
        title: props.title,
        children: props.confirmationMessage,
        callback: (confirm) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!confirm) {
                setSuccessNotification(undefined);
                setSuccess(undefined);
                return;
            }
            setLoading(true);
            try {
                const data = yield props.onConfirm();
                setLoading(false);
                setErrorNotification(undefined);
                setSuccessNotification(props.successMessage);
                setSuccess(data);
            }
            catch (error) {
                setLoading(false);
                setSuccessNotification(undefined);
                setErrorNotification(error);
            }
        }),
    });
    const onClick = () => {
        setErrorNotification(undefined);
        setSuccessNotification(undefined);
        setSuccess(undefined);
        setConfirmation(true);
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(EnhanceChildren_1.EnhanceChildren, Object.assign({ enhance: { onClick, disabled: loading } }, { children: props.children }), void 0), successNotification, errorNotification, confirmation, loader] }, void 0));
}
exports.ConfirmationAction = ConfirmationAction;
//# sourceMappingURL=Confirmation.js.map